
export const SCREEN_TYPES = {
  'OPTION': 'OPTION',
  'SELECT_LOCATION': 'SELECT_LOCATION',
  'DATE_AND_TIME': 'DATE_AND_TIME',
  'MESSAGE': 'MESSAGE',
  "USER_SIGN_UP": "USER_SIGN_UP", 
  "BILLING" : "BILLING"
}

export default [ 
  {
    type: SCREEN_TYPES.USER_SIGN_UP,
    heading: "First, let's create your account.",
    button: "Sign Up",
    fields: [
      {
        field: "firstName",
        label: "First name",
        type: "text",
        required: true,
      },
      {
        field: "lastName",
        label: "Last name",
        type: "text",
        required: true,
      },
      {
        field: "gender",
        label: "Gender",
        type: "select",
        options: [
          { label: "male", value: "male" },
          { label: "female", value: "female" },
          { label: "other", value: "other" }
        ],
        required: true,
      },
      {
        field: "birthdate",
        label: "Birthdate",
        type: "date",
        required: true,
      },
      {
        field: "phone",
        label: "Phone number",
        type: "tel",
        placeholder: "(555)555-5555",
        required: true,
      },
      {
        field: "email",
        label: "Email address",
        type: "email",
        required: true,
      },
      {
        field: "password",
        label: "Set password",
        type: "password",
        required: true,
      },
      {
        field: "confirmPassword",
        label: "Confirm password",
        type: "password",
        required: true,
      },
      {
        field: "communicationConsent",
        label: "I authorize Kindbody to send me email or text messages which may include unencrypted protected health information.",
        type: "checkbox",
        required: false,
      },
    ]
  },
  {
    type: SCREEN_TYPES.OPTION,
    heading: 'Select an appointment type',
    field: 'consultType',
    options: [
      {
        label: 'Fertility Assessment',
        value: 'Fertility Assessment'
      },
      {
        label: 'Phone Consultation',
        value: 'Phone Consultation'
      }
    ]
  },
  {
    type: SCREEN_TYPES.SELECT_LOCATION,
    heading: 'Select a clinic location',
    field: 'location',
  },
  {
    type: SCREEN_TYPES.DATE_AND_TIME,
    heading: 'Select a date and time',
    field: 'appointment',
  },
  {
    type: SCREEN_TYPES.BILLING,
    heading: 'Almost there',
    button: "Book Now",
    fields: [
      {
        field: "cardNumber",
        label: "Card number",
        type: "number",
        required: true,
      },
      {
        field: "expDate",
        label: "Expiration Date",
        type: "number",
        required: true,
      },
      {
        field: "cvc",
        label: "CVC",
        type: "number",
        required: true,
      },
      {
        field: "cardHolderName",
        label: "Card holder name",
        type: "text",
        required: true,
      },
      {
        field: "zipCode",
        label: "Zip code",
        type: "number",
        required: true,
      },
      {
        field: "membershipTerms",
        label: "I have read and agree to the Kindbody ",
        type: "checkbox",
        required: true,
      },
    ]
  },
  {
    type: SCREEN_TYPES.MESSAGE,
    finale: true,
    heading: 'Booked!',
    button: 'Enter Dashboard',
  }
]


// WEBPACK FOOTER //
// ./src/data/scheduleConsult.js